import React, { useState } from 'react';

import useResources from 'components/Common/Resources/Hooks/useResources';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import Card from './Card';
import Filters from './Filters';
import Header from './Header';

export default function Resources() {
  const { resources } = useResources();

  const [keyword, setKeyword] = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);

  if (resources === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="pb-5 pt-5" />
    );
  }

  const promoteResource = resources.find((item) => item.attributes.manager_promote);

  const filteredResources = resources
    && Object.values(resources).filter((item) => {
      let available = false;
      if (
        item.attributes.title
          .toLowerCase()
          .includes(keyword.toLowerCase())
        && item.id !== promoteResource?.id
        && (selectedCategories.some((element) => item.attributes.categories.includes(element))
           || selectedCategories.length === 0)
      ) { available = true; }

      return available;
    });

  const checkCategory = (value) => {
    if (selectedCategories.includes(value)) {
      setSelectedCategories(selectedCategories.filter((item) => item !== value));
    } else {
      setSelectedCategories([...selectedCategories, value]);
    }
  };

  const categories = [...new Set(resources.map((item) => item.attributes.categories).flat())];

  return (
    <>
      <Header resource={promoteResource} />
      <section>
        <Filters
          setKeyword={setKeyword}
          checkCategory={checkCategory}
          categories={categories}
        />

        <ResponsiveMasonry columnsCountBreakPoints={{ 1: 1, 768: 2, 1200: 2 }}>
          <Masonry gutter="1rem">
            {filteredResources.map((resource) => (
              <div key={resource.id} className="mb-3">
                <Card resource={resource} />
              </div>
            ))}
          </Masonry>
        </ResponsiveMasonry>
      </section>
    </>
  );
}
